import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export const ShotType = ({ name, onRemove }) => {
    return (
        <>
            <div
                key={name}
                className="flex align-items-center p-4"
            >
                <FontAwesomeIcon
                    onClick={() => onRemove(name)}
                    cursor="pointer"
                    size="sm"
                    icon={faTrash}
                />
                <span className="m-l-16">{name}</span>
            </div>
        </>
    );
};
